import { type SavedCredentialRequest as Request } from './saved-credential.query';
import { SavedCredentialRequest } from './SavedCredentialRequest';

export const ChatSavedCredentialRequest = ({
  onBeforeSubmit,
  request,
}: {
  onBeforeSubmit?: () => void | Promise<void>;
  request: Request | null | undefined;
}) => {
  return request ? (
    <SavedCredentialRequest
      key={request.request_id}
      request={request}
      onBeforeSubmit={onBeforeSubmit}
      overlay
    />
  ) : null;
};
